module.exports = __webpack_public_path__ + "static/media/KNY BG.57ab5124.png";